import { JobRoleStatus, jobRoleStatusLabels } from '../types';

const GLYPH: Record<number, string> = { [JobRoleStatus.Draft]: '✎', [JobRoleStatus.Active]: '✓', [JobRoleStatus.Archived]: '▣' };
const CLASS: Record<number, string> = {
  [JobRoleStatus.Draft]: 'badge--pending',
  [JobRoleStatus.Active]: 'badge--approved',
  [JobRoleStatus.Archived]: 'badge--neutral',
};

/** A status is always the word, never only a colour: the glyph is decoration (aria-hidden) and the label carries the meaning. */
export function RoleStatusBadge({ status }: { status: number }) {
  const label = jobRoleStatusLabels[status] ?? 'Unknown';
  return (
    <span className={`badge ${CLASS[status] ?? 'badge--neutral'}`}>
      <span aria-hidden="true">{GLYPH[status] ?? '?'} </span>
      {label}
    </span>
  );
}
